'use strict';

try {
  module.exports = require('bindings')('validation');
} catch (e) {
  module.exports = require('./fallback');
}



//////////////////
// WEBPACK FOOTER
// ./~/utf-8-validate/index.js
// module id = 1900
// module chunks = 0